
import { useParams } from 'react-router-dom';
import { ClienteFormState } from '../../../context/cliente/ClienteFormState';
import { Form } from './formResetAccount';

export const ClienteResetFormPage = () => {
  const { id } = useParams();

  return (
    <ClienteFormState>
        <br />
        <Form title="Confirmar Datos" />
    </ClienteFormState>
  );
};
